var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { getAttributes } from '../../../utils';
var I = function (_a) {
    var props = __rest(_a, []);
    var url = props.url, title = props.title, name = props.name, width = props.width, height = props.height, onLoad = props.onLoad, additionalParams = props.additionalParams, id = props.id, rest = __rest(props, ["url", "title", "name", "width", "height", "onLoad", "additionalParams", "id"]);
    var configI = __assign({ src: url, width: width, height: height, title: title, onLoad: onLoad, name: name, id: id, frameBorder: '0' }, getAttributes(rest));
    // eslint-disable-next-line jsx-a11y/iframe-has-title
    return React.createElement("iframe", __assign({}, configI, additionalParams));
};
export { I as Iframe };
